export const categories = [
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-alert-line', description: '网红塌房实锤合集' },
  { slug: 'mingxing-bagua', name: '明星八卦', icon: 'ri-star-line', description: '娱乐圈最新爆料' },
  { slug: 'meiri-dasai', name: '每日大赛', icon: 'ri-trophy-line', description: '每日吃瓜大赛精选' },
  { slug: 'fancha-shipin', name: '反差视频', icon: 'ri-contrast-2-line', description: '高清反差视频资源' },
  { slug: 'zuixin-dagua', name: '最新大瓜', icon: 'ri-fire-line', description: '今日最热大瓜' },
  { slug: 'heise-changshi', name: '黑料实锤', icon: 'ri-hammer-line', description: '实锤黑料一网打尽' },
];

export const articles = [
  {
    id: 1,
    title: '某千万粉丝网红直播间翻车，私下真实面目曝光引全网哗然',
    slug: 'wanghong-zhibo-fanche',
    category: 'wanghong-fanche',
    excerpt: '近日，一位拥有千万粉丝的知名网红在直播中意外翻车，私下录音被曝光，与其精心打造的清纯人设形成巨大反差，引发全网热议...',
    content: `<p>近日，一位拥有千万粉丝的知名网红在直播中意外翻车，私下录音被曝光，与其精心打造的清纯人设形成巨大反差，引发全网热议。据知情人士透露，该网红在私下聚会中的言论与其公开形象截然不同，涉及多起争议事件。</p><p>事件起源于一段被曝光的私密对话录音，录音中该网红不仅对粉丝群体出言不逊，还涉及对其他同行的人身攻击。这段录音一经曝光，立即在各大社交平台引发轩然大波。</p><p>该网红的粉丝群体迅速分化，部分铁粉坚持维护偶像，认为录音可能经过恶意剪辑；而更多网友则对其人设崩塌表示震惊和失望。截至目前，该网红的社交媒体账号已掉粉超过200万。</p><p>业内人士分析认为，这是近年来网红圈影响力最大的一次翻车事件，也再次引发了公众对网红经济真实性的质疑。多位圈内资深人士呼吁加强行业自律，建立更完善的网红信用评价体系。</p>`,
    imageQuery: 'Dramatic scene of a livestream setup with neon ring light falling over, shattered makeup products on a dark floor, dim moody lighting with pink and cyan accents, cinematic composition, editorial photography style with deep shadows and moody atmosphere, simple dark background',
    views: 2895634,
    comments: 48562,
    date: '2026-07-06',
    hot: true,
    featured: true,
  },
  {
    id: 2,
    title: '顶流男星深夜密会神秘女子，酒店共度8小时视频实锤流出',
    slug: 'dingliu-nanxing-mihui',
    category: 'mingxing-bagua',
    excerpt: '某顶流男星被拍到深夜与一名神秘女子进入某五星级酒店，两人在酒店内共度8小时后分别离开，全程被狗仔队蹲守拍到高清画面...',
    content: `<p>某顶流男星被拍到深夜与一名神秘女子进入某五星级酒店，两人在酒店内共度8小时后分别离开，全程被狗仔队蹲守拍到高清画面。该男星此前一直以"单身贵族"人设示人，此次事件使其形象受到严重质疑。</p><p>据现场目击者描述，该男星于凌晨1点左右抵达酒店，一名身穿黑色连衣裙的神秘女子早已在大堂等候。两人短暂交谈后一同进入电梯，直至次日上午9点才分别从不同出口离开。</p><p>事件曝光后，该男星的经纪公司迅速发布声明，称两人只是普通朋友关系，在酒店是进行工作讨论。然而，这一解释并未获得网友认可，评论区一片质疑声。</p><p>值得注意的是，该男星目前正有三部待播剧和两个代言在身，此次事件是否会影响其商业价值还有待观察。业内分析师预测，如果事态持续发酵，其代言的品牌方可能会重新评估合作。</p>`,
    imageQuery: 'Luxury hotel entrance at night with paparazzi camera flash effect, sleek black car pulling up, dramatic noir lighting with neon city reflections, cinematic wide shot, editorial photography with deep contrast and moody atmosphere, dark urban background',
    views: 5123789,
    comments: 89241,
    date: '2026-07-05',
    hot: true,
    featured: true,
  },
  {
    id: 3,
    title: '某综艺节目录制现场爆发激烈冲突，两位嘉宾当场翻脸画面曝光',
    slug: 'zongyi-jiechong',
    category: 'meiri-dasai',
    excerpt: '在某热门综艺节目的最新一期录制现场，两位人气嘉宾因游戏规则产生分歧，从语言争执升级为肢体冲突，现场一度陷入混乱...',
    content: `<p>在某热门综艺节目的最新一期录制现场，两位人气嘉宾因游戏规则产生分歧，从语言争执升级为肢体冲突，现场一度陷入混乱。据悉，节目组紧急叫停录制，并进行了长达两小时的调解。</p><p>目击者透露，冲突的起因是游戏环节中一方认为对方存在违规行为，双方各执一词互不相让。起初只是言语上的争执，但随着情绪升级，其中一位嘉宾突然拍桌而起，场面瞬间失控。</p><p>节目导演随后介入调解，但两位嘉宾均拒绝让步，最终导致当天的录制被迫中止。节目组表示将重新评估该期节目的播出方案，不排除进行重新录制的可能。</p><p>此事在业内引起了广泛讨论，多位综艺制作人表示，真人秀节目中嘉宾之间的真实冲突虽然具有话题性，但也需要控制在合理范围内，避免对节目品牌造成负面影响。</p>`,
    imageQuery: 'TV studio set with dramatic red and blue lighting, two silhouettes confronting each other on stage, cameras and crew in background blurred, intense atmosphere with spotlight beams cutting through haze, cinematic documentary style, dark studio background',
    views: 1789456,
    comments: 32145,
    date: '2026-07-06',
    hot: true,
    featured: false,
  },
  {
    id: 4,
    title: '知名女星私下真实颜值曝光，素颜与精修图差距大到让人认不出',
    slug: 'nvxing-suyan-chaju',
    category: 'fancha-shipin',
    excerpt: '有网友偶遇某知名女星在商场逛街，随手拍下的素颜照片在网上疯传。对比其社交媒体上发布的精修美图，差距之大令粉丝直呼"认不出"...',
    content: `<p>有网友偶遇某知名女星在商场逛街，随手拍下的素颜照片在网上疯传。对比其社交媒体上发布的精修美图，差距之大令粉丝直呼"认不出"。这组照片在短短几小时内就获得了超过500万的浏览量。</p><p>照片中，该女星身穿休闲服装，未施粉黛，与平时在镜头前精致妆容的形象判若两人。虽然素颜状态下的皮肤状况尚可，但整体气色和五官轮廓与精修图中的差距确实十分明显。</p><p>部分网友对此表示理解，认为明星也是普通人，素颜和精修有差距再正常不过；但也有不少网友认为，该女星平时过度营销美貌人设，此次反差实在太大。</p><p>该女星的经纪团队尚未对此事作出回应。不过有业内人士透露，近期女星的工作安排并未受到影响，多个品牌代言合作仍在正常进行中。</p>`,
    imageQuery: 'Split composition showing glamorous editorial beauty portrait on one side and casual natural candid on the other, dramatic lighting contrast, fashion magazine style meets street photography, moody atmospheric tones, dark simple background with spotlight effect',
    views: 3456210,
    comments: 67231,
    date: '2026-07-04',
    hot: false,
    featured: true,
  },
  {
    id: 5,
    title: '年度最大瓜：某知名企业家涉嫌造假被立案调查，金额高达数十亿',
    slug: 'qiyejia-zaojia-beian',
    category: 'zuixin-dagua',
    excerpt: '据权威消息源透露，某知名企业家因涉嫌财务造假已被相关部门立案调查，涉案金额高达数十亿元。该公司股价在消息传出后暴跌超过70%...',
    content: `<p>据权威消息源透露，某知名企业家因涉嫌财务造假已被相关部门立案调查，涉案金额高达数十亿元。该公司股价在消息传出后暴跌超过70%，市值蒸发超过500亿元。</p><p>调查显示，该企业存在通过虚构交易、虚增收入等手段粉饰财务报表的嫌疑。相关监管部门已经成立专案组进驻公司进行全面核查，多名高管被限制出境。</p><p>这一消息在投资圈引起了巨大震动，多家机构投资者紧急召开风险评估会议。有分析师指出，这是近年来资本市场上影响最大的财务造假案件之一。</p><p>该企业的供应商和合作伙伴也受到了不同程度的波及，部分已暂停合作并启动法律程序追讨欠款。业内人士呼吁加强上市公司监管，保护投资者合法权益。</p>`,
    imageQuery: 'Corporate office building at night with lights flickering dramatically, stock market charts showing sharp decline on dark screens, emergency documents scattered on desk, noir thriller atmosphere with cyan and red accent lighting, cinematic composition, dark corporate environment',
    views: 7890234,
    comments: 123456,
    date: '2026-07-03',
    hot: true,
    featured: true,
  },
  {
    id: 6,
    title: '网红情侣分手互撕，私密聊天记录曝光内容劲爆尺度惊人',
    slug: 'wanghong-fenshou-husi',
    category: 'wanghong-fanche',
    excerpt: '一对拥有数百万粉丝的网红情侣近日宣布分手，随后双方在社交平台展开激烈的互撕大战，大量私密聊天记录被曝光，内容令人瞠目...',
    content: `<p>一对拥有数百万粉丝的网红情侣近日宣布分手，随后双方在社交平台展开激烈的互撕大战，大量私密聊天记录被曝光，内容令人瞠目。这场分手大戏持续了整整三天，相关话题累计阅读量突破10亿。</p><p>男方率先发文指责女方在恋爱期间多次出轨，并晒出了多张聊天截图作为证据。女方则反击称男方有严重的控制欲问题，长期对其进行精神打压，并同样晒出了相应的对话记录。</p><p>随着双方你来我往的隔空交锋，越来越多的私密细节被公之于众，包括两人的消费账单、旅行记录甚至家庭纠纷。吃瓜群众纷纷表示"这瓜太大，一时间吃不完"。</p><p>有心理学专家分析认为，网红情侣在公众面前展示的甜蜜形象往往是精心包装的结果，真实的感情状况可能与表象相去甚远。建议公众理性吃瓜，不要过度代入。</p>`,
    imageQuery: 'Two smartphones facing each other on a dark reflective surface with broken heart neon sign reflection, shattered glass effect, messy breakup atmosphere with scattered polaroid photos, moody pink and cyan lighting, editorial still life photography, dark background',
    views: 4567890,
    comments: 78456,
    date: '2026-07-05',
    hot: true,
    featured: false,
  },
  {
    id: 7,
    title: '某选秀节目暗箱操作被前工作人员曝光，投票数据造假触目惊心',
    slug: 'xuanxiu-anxiang-caozuo',
    category: 'heise-changshi',
    excerpt: '一名自称是某热门选秀节目前工作人员的人士在社交平台发布长文，详细揭露了节目组操控投票结果的内部操作流程，引发舆论风暴...',
    content: `<p>一名自称是某热门选秀节目前工作人员的人士在社交平台发布长文，详细揭露了节目组操控投票结果的内部操作流程，引发舆论风暴。该工作人员自称因良心不安而选择站出来揭露真相。</p><p>根据爆料内容，节目组会通过后台系统直接修改选手的得票数据，以确保"预定"的选手能够晋级。此外，节目组还会刻意剪辑选手的表现片段，引导观众对特定选手产生好感或反感。</p><p>该爆料迅速登上热搜榜首，节目组紧急发布声明否认所有指控，并表示将通过法律途径追究造谣者的责任。然而，越来越多的前参赛选手开始站出来，证实了类似的暗箱操作确实存在。</p><p>广电监管部门表示已注意到相关舆情，将对选秀节目的投票机制进行专项检查。业内人士认为，这次事件可能会成为选秀节目行业规范化的重要转折点。</p>`,
    imageQuery: 'Dark control room with multiple monitors showing voting data and graphs, dramatic spotlight on a single desk with scattered papers, mysterious surveillance atmosphere, cinematic thriller lighting with red accent, dark technical environment',
    views: 2345678,
    comments: 45678,
    date: '2026-07-02',
    hot: false,
    featured: false,
  },
  {
    id: 8,
    title: '知名歌手涉嫌抄袭被原创作者公开维权，完整对比视频铁证如山',
    slug: 'geshou-chaoxi-weiquan',
    category: 'mingxing-bagua',
    excerpt: '一位独立音乐人在社交平台发布了一段详细的新歌抄袭对比视频，指控某知名歌手的最新单曲与其作品存在大量相似之处...',
    content: `<p>一位独立音乐人在社交平台发布了一段详细的新歌抄袭对比视频，指控某知名歌手的最新单曲与其作品存在大量相似之处。对比视频从旋律、编曲、歌词结构等多个维度进行了逐一分析，证据确凿。</p><p>该独立音乐人表示，自己的作品早在两年前就已公开发布，而该知名歌手的新歌在旋律走向和编曲风格上与其作品高度重合，相似度超过80%。他已委托律师向法院提起诉讼。</p><p>知名歌手的经纪公司对此回应称"纯属巧合"，并表示所有作品均为原创团队独立创作。但音乐圈的业内人士在听完对比后普遍认为，两首歌的相似之处"很难用巧合来解释"。</p><p>这已经不是该知名歌手第一次陷入抄袭争议，此前也曾有多次类似指控但最终都不了了之。网友们呼吁各大平台建立更严格的音乐抄袭审核机制。</p>`,
    imageQuery: 'Music studio with sheet music and audio waveform comparison on dual monitors, dramatic split lighting showing original vs copy, vinyl records scattered on dark desk, moody atmosphere with cyan and amber accent lighting, editorial music documentary style',
    views: 1234567,
    comments: 23456,
    date: '2026-07-01',
    hot: false,
    featured: false,
  },
  {
    id: 9,
    title: '网红直播带货翻车现场：声称纯天然的产品被检测出含违禁成分',
    slug: 'wanghong-daihuo-fanche',
    category: 'wanghong-fanche',
    excerpt: '某网红在直播中大力推荐的"纯天然"护肤品被消费者送去第三方检测，结果显示含有多种违禁化学成分，该网红面临严重信任危机...',
    content: `<p>某网红在直播中大力推荐的"纯天然"护肤品被消费者送去第三方检测，结果显示含有多种违禁化学成分，该网红面临严重信任危机。这场带货翻车事件涉及金额据估算超过5000万元。</p><p>一位消费者在使用该产品后出现皮肤过敏症状，遂将产品送往权威检测机构进行分析。检测报告显示，该产品中含有糖皮质激素等多种严禁在化妆品中使用的成分。</p><p>事件曝光后，该网红立即删除了所有相关推广内容，并关闭了评论功能。但愤怒的消费者已经在多个平台发起了集体维权，要求退一赔三。</p><p>市场监管部门已介入调查，涉事产品的生产企业也被责令停产整顿。业内专家提醒消费者，直播带货中的"纯天然""无添加"等宣传语往往缺乏科学依据，购买前需要保持理性判断。</p>`,
    imageQuery: 'Cosmetic products scattered on a laboratory testing table with microscope and chemical analysis equipment, dramatic lighting with test tube glow, investigation atmosphere, editorial product photography with moody shadows, dark scientific background',
    views: 3890123,
    comments: 57890,
    date: '2026-06-30',
    hot: false,
    featured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '吃瓜小能手',
    role: '忠实用户 3年',
    avatarQuery: 'Stylish young Asian person avatar with trendy street fashion style, neon lit portrait, cyberpunk aesthetic, circular headshot format, clean background with subtle pink tones, editorial portrait photography',
    content: '911爆料网真的是我每天必刷的网站！更新速度快得惊人，每次有大瓜我都是从这里第一时间知道的。推荐给所有爱吃瓜的朋友！',
    rating: 5,
  },
  {
    id: 2,
    name: '八卦雷达',
    role: 'VIP会员 2年',
    avatarQuery: 'Professional looking young woman avatar with modern minimalist style, warm studio portrait lighting, clean circular headshot format, neutral grey background, editorial portrait photography',
    content: '从微博转过来的，这里的瓜不仅新鲜而且有深度，很多独家内容别的平台根本看不到。分类也很清晰，找瓜特别方便。',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜吃瓜人',
    role: '活跃用户 1年',
    avatarQuery: 'Casual young male avatar with laid-back street style, moody warm portrait lighting, circular headshot format, dark atmospheric background, editorial portrait photography',
    content: '每天睡前必刷911，已经成了生活习惯。最喜欢每日大赛板块，网友们的评论比瓜本身还精彩，笑死我了哈哈。',
    rating: 5,
  },
  {
    id: 4,
    name: '真相追踪者',
    role: '资深用户 2年',
    avatarQuery: 'Intellectual looking young person avatar with glasses and thoughtful expression, soft studio lighting, circular headshot format, clean warm background, editorial portrait photography',
    content: '非常专业的吃瓜平台，不仅有爆料还有深度分析，很多网红翻车事件的来龙去脉都梳理得特别清楚，真正的吃瓜第一站。',
    rating: 5,
  },
  {
    id: 5,
    name: '瓜田里的猹',
    role: '新用户 6个月',
    avatarQuery: 'Playful young student avatar with casual hoodie style, bright and energetic portrait lighting, circular headshot format, simple background with warm tones, editorial portrait photography',
    content: '朋友推荐来的，一入瓜田深似海啊！界面简洁没有乱七八糟的广告，加载速度也很快，体验秒杀其他八卦网站。',
    rating: 4,
  },
  {
    id: 6,
    name: '娱乐圈观察员',
    role: '认证用户 3年',
    avatarQuery: 'Sophisticated young professional avatar with refined style, elegant studio portrait lighting, circular headshot format, sophisticated dark background, editorial portrait photography',
    content: '做娱乐自媒体三年了，911爆料网是我最重要的信息源之一。很多热门话题我都是从这里挖到第一手素材的，强烈推荐！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '911爆料网的内容多久更新一次？',
    answer: '911爆料网全天候7x24小时实时更新，我们的编辑团队和社区爆料人随时在线，确保您不会错过任何一个最新大瓜。热门事件从发生到上线平均不超过30分钟，真正做到吃瓜第一站。',
  },
  {
    question: '网站上的爆料内容真实可靠吗？',
    answer: '我们采用严格的三级审核机制：社区用户爆料后，先由AI系统进行初步甄别，再由专业编辑团队进行事实核查，最后经过主编终审才会发布。对于无法核实的信息，我们会明确标注"待核实"标签，让用户理性吃瓜。',
  },
  {
    question: '如何使用911爆料网的分类功能？',
    answer: '在首页顶部分类导航栏中，您可以按"网红翻车""明星八卦""每日大赛""反差视频""最新大瓜""黑料实锤"等类别筛选感兴趣的内容。每个分类页面都支持按时间和热度排序，方便您快速找到最想看的瓜。',
  },
  {
    question: '911爆料网是否需要注册才能浏览？',
    answer: '不需要！911爆料网所有内容完全免费开放，无需注册即可畅快浏览。我们承诺永不收费、永无付费墙，让每一位吃瓜群众都能平等地享受吃瓜的快乐。如果您想参与评论互动，可以选择注册账号。',
  },
  {
    question: '如何向911爆料网投稿爆料？',
    answer: '您可以通过网站底部的"联系我们"获取投稿邮箱，发送您的爆料内容。我们承诺对所有爆料人信息严格保密，对于独家重磅爆料，我们还会提供丰厚的爆料奖励。投稿时请尽量提供图片、视频等证据材料。',
  },
  {
    question: '手机上可以访问911爆料网吗？',
    answer: '当然可以！911爆料网采用全响应式设计，完美适配手机、平板和电脑等各种设备。无需下载任何APP，直接在手机浏览器中打开即可获得流畅的吃瓜体验。',
  },
];